export type WeekdayStyle = "short" | "long";

export function formatDayMonthWithWeekday(date: Date, style: WeekdayStyle = "short") {
  const weekday = date.toLocaleDateString("fr-FR", { weekday: style });
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const week = style === "short" && !weekday.endsWith(".") ? `${weekday}.` : weekday;
  return `${week} ${dd}/${mm}`;
}
